module.exports = __webpack_public_path__ + "static/img/back_icon_4.ef658bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/back_icon_4.png
// module id = vr9A
// module chunks = 1